<style>
.table-border_ {
  font-family: arial, sans-serif;
  border-collapse: collapse;
  width: 100%;
}
.table_w {
  font-family: arial, sans-serif;
  width: 100%;
}

.table-border_ td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}

.table-border_ tr:nth-child(even) {
  background-color: #dddddd;
}
.table_w_ {
  width: 45%;
  font-family: arial, sans-serif;
  float: right;
}
.block_right {
  text-align: end !important;
}
</style>

<template>
  <div class="content-wrapper class_trigger" v-if="invoice.id">
    <!-- pdf-orientation="landscape" -->
    <VueHtml2pdf
      :show-layout="false"
      :float-layout="false"
      :enable-download="false"
      :preview-modal="true"
      :paginate-elements-by-height="1400"
      filename="myPDF"
      :pdf-quality="2"
      :manual-pagination="false"
      pdf-format="a4"
      pdf-content-width="100%"
      ref="html2Pdf"
    >
      <section slot="pdf-content">
        <div class="row">
          <div class="col-12">
            <table class="table_w" cellpadding="0" cellspacing="0">
              <thead>
                <tr>
                  <th style="
                      width: 60% !important;
                      border: none;
                      padding: 22px;
                      background: black;
                      color: white;
                    ">Invoice</th>
                  <th style="
                      width: 40% !important;
                      border: none;
                      padding: 22px;
                      background: #ddd;
                      text-align: center;
                      color: black;
                    ">
                    Amount Due
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="
                      width: 60% !important;
                      padding-left: 20px;
                      background: black;
                      color: white;
                      padding-bottom: 20px;
                    ">
                    {{appSettings.appSettings.company_name}}
                  </td>
                  <td style="width: 40% !important; background: #ddd"></td>
                </tr>
              </tbody>
            </table>

            <table class="table_w" cellpadding="0" cellspacing="0">
              <thead>
                <tr>
                  <th
                    style="width: 50% !important; border: none; padding: 22px"
                  >
                    Bill To : <br />
                    <span style="font-weight: normal; font-size: 14px"
                      >{{ invoice.company.company_name }} ({{
                        invoice.company.comapny_number
                      }})</span
                    >
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td
                    style="
                      width: 50% !important;
                      padding-left: 20px;
                      padding-bottom: 20px;
                    "
                  >
                    <!-- ​<span>burhan rao </span> -->
                    <br />{{ invoice.company.address }}<br /><br />
                    {{ invoice.company.company_phone }}<br />
                    {{ invoice.company.company_email }}
                  </td>
                  <td
                    style="
                      width: 30% !important;
                      text-align: center;
                      position: absolute;
                      right: 0px;
                      top: 136px;
                    "
                  >
                    Invoice Number: {{ invoice.invoice_number }} <br/>
                    Invoice Dat​e: {{ invoice.invoice_date }}
                    <!-- <br />
                    Payment Due: November 16, 2021
                    <br />
                    <span>Amount Due (USD): $0.00​</span> -->
                  </td>
                </tr>
              </tbody>
            </table>
            <div class="row">
              <div
                class="
                  col-12
                  table-border_
                  table-responsive
                  custom-scrollbar
                  table-view-responsive
                "
              >
                <table class="table mb-0">
                  <tr>
                    <th style="color: var(--side-bar-dark-text-color)">
                      Items
                    </th>
                    <th style="color: var(--side-bar-dark-text-color)">
                      Column Quantity
                    </th>
                    <th style="color: var(--side-bar-dark-text-color)">
                      Price
                    </th>
                    <th style="color: var(--side-bar-dark-text-color)">
                      Amount
                    </th>
                  </tr>
                  <tr>
                    <td style="color: black !important">
                      {{ invoice.package.title }}
                    </td>
                    <td style="color: black !important">1</td>
                    <td style="color: black !important">
                      {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}
                    </td>
                    <td style="color: black !important">
                      {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}
                    </td>
                  </tr>
                </table>
              </div>
            </div>

            <div style="margin-top: 20px; margin-bottom: 20px">
              <hr style="color: #ddd" />
            </div>

            <div
              style="
                width: 100%;
                text-align: end !important;
                position: relative;
                right: 0px;
              "
              class="block_right"
            >
              <div style="margin-right: 10%">
                Total:
                <span
                  style="
                    font-weight: normal;
                    font-size: 14px;
                    margin-left: 20px;
                  "
                >
                  {{ appSettings.appSettings.currency_symbol }}{{ invoice.amount }}</span
                >
              </div>
              <!-- <div
                style="
                  margin-top: 10px;
                  margin-right: 10%;
                  border-top: 1px solid #ddd;
                  border-bottom: 1px solid #ddd;
                  display: inline-block;
                  padding-top: 10px;
                  padding-bottom: 10px;
                "
              >
                Amount Du​e (USD):
                <span style="font-weight: bold; font-size: 14px; margin-left: 20px">
                  $0.00</span
                >
              </div> -->
            </div>

            <div>
              <p>
                <span style="font-weight: bold">Banking Detail:</span><br />
                <span v-html="appSettings.appSettings.banking_detail"></span>
              </p>
            </div>
            <div>
              <p>
                <span style="font-weight: bold">Note:</span><br />
                <span v-html="appSettings.appSettings.invoice_note"></span>
              </p>
            </div>
            <div style="margin-top: 20px; margin-bottom: 20px">
              <hr style="color: #ddd" />
            </div>
          </div>
        </div>
      </section>
    </VueHtml2pdf>
    <div class="text-right">
      <button @click.prevent="generateReport" class="btn btn-primary">Print</button>
    </div>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin";
import { INVOICE_SHOW } from "../../../../Config/ApiUrl";
import AppLibrary from "../../../../Helpers/AppLibrary";
import { axiosGet } from "../../../../Helpers/AxiosHelper";
// import VueHtml2pdf from "vue-html2pdf";
export default {
  name: "InvoiceView",
  extends: AppLibrary,
  mixins: [FormMixin],
  props: {
    id: [Number, String],
  },
  data() {
    return {
      invoice: {},
    };
  },
  // components: {
  //   VueHtml2pdf,
  // },
  computed: {
    appSettings(){
      return this.$store.state.settings;
    }
  },
  methods: {
    generateReport() {
      this.$refs.html2Pdf.generatePdf();
    },
    getInvoice() {
      // let myLocation = location.href;
      // let split = myLocation.split("/");
      
      // let id = split[6].split("?")[0];
      axiosGet(INVOICE_SHOW + "/" + this.id)
        .then((res) => {
          this.invoice = res.data;
          
        })
        .catch((error) => {
          
        });
    },
  },
  mounted() {
    this.getInvoice();
    // this.generateReport();
    // $('.class_trigger .btn-primary').hide();
    // setTimeout(() => {
    //   // 
    //   $(".class_trigger .btn-primary").trigger("click");
    // }, 4000);
  },
};
</script>
